import {
	GetProductionLotTimelineQuery,
	GetShrinkLossLotsQuery,
	GetShrinkLossReportQuery
} from "~/gql/queries/produce/shrinkLoss.generated";

export const shrinkLossEndpoints = {
	GetProductionLotTimeline: {
		providesTags: ["ProductionLots", "ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetProductionLotTimelineQuery) => res
	},
	GetShrinkLossLots: {
		providesTags: ["ProductionLots", "ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetShrinkLossLotsQuery) => res
	},
	GetShrinkLossReport: {
		providesTags: ["ProductionLots", "ProductionJobs"] as AddTagTypes,
		transformResponse: (res: GetShrinkLossReportQuery) => res
	}
};
